import klaxMascotVideoLight from 'assets/images/magnific_mascott-t-light.mp4';
import klaxMascotVideoDark from 'assets/images/magnific_mascott-t.mp4';
import { useState } from 'react';
import { useTheme } from 'components/core/theme-provider';
import i18n from 'i18n/i18n';
import { cn } from 'lib/utils';
import { SeliseAssistantLogo } from 'features/chat/components/MessageLoading';

const loadingMessagesByLanguage = {
  en: [
    'Warming up the magic',
    'Teaching pixels to behave',
    'Assembling clever thoughts',
    'Polishing your next screen',
    'Brewing something useful',
    'Convincing the app to sparkle',
  ],
  de: [
    'Wir bringen die Magie in Schwung',
    'Wir bringen die Pixel auf Kurs',
    'Wir setzen clevere Gedanken zusammen',
    'Wir polieren deinen naechsten Screen',
    'Wir brauen etwas Nuetzliches zusammen',
    'Wir ueberreden die App zu funkeln',
  ],
} as const;

export function LoadingOverlay() {
  const [messageIndex] = useState(
    () => Math.floor(Math.random() * loadingMessagesByLanguage.en.length)
  );
  const { resolvedTheme } = useTheme();
  const storedLanguage = localStorage.getItem('language');
  const storedTheme = localStorage.getItem('theme');
  const documentTheme = document.documentElement.classList.contains('dark') ? 'dark' : 'light';
  const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  const currentLanguage = storedLanguage || i18n.language || 'en-US';
  const languageCode = currentLanguage.split('-')[0].toLowerCase() as keyof typeof loadingMessagesByLanguage;
  const loadingMessages = loadingMessagesByLanguage[languageCode] ?? loadingMessagesByLanguage.en;
  const loadingMessage = loadingMessages[messageIndex % loadingMessages.length];
  const effectiveTheme = storedTheme === 'dark'
    ? 'dark'
    : storedTheme === 'light'
      ? 'light'
      : documentTheme === 'dark'
        ? 'dark'
        : resolvedTheme === 'dark'
          ? 'dark'
          : systemTheme;
  const isDark = effectiveTheme === 'dark';
  const klaxMascotVideo = isDark ? klaxMascotVideoDark : klaxMascotVideoLight;
  const backgroundColor = isDark
    ? 'hsl(240 5% 9%)'
    : 'hsla(0, 0%, 100%, 0.92)';

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm"
      style={{ backgroundColor }}
      data-testid="loading-overlay"
    >
      <div className="flex flex-col items-center gap-3">
        <div className="size-[80px] overflow-hidden">
          {/* <video
            key={effectiveTheme}
            src={klaxMascotVideo}
            autoPlay
            loop
            muted
            playsInline
            aria-hidden
            className={cn(
              'size-full object-cover',
              isDark ? 'scale-[1.30] mix-blend-screen' : 'scale-[1.30]'
            )}
            width={50}
            height={50}
          /> */}
          <SeliseAssistantLogo className="size-full object-cover" />
        </div>

        <p
          className={cn(
            'font-sans text-xl sm:text-3xl 2xl:text-[40px] font-normal leading-none',
            isDark ? 'text-[#999781]' : 'text-foreground'
          )}
        >
          {loadingMessage}
        </p>
      </div>
    </div>
  );
}
